"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initVideoWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ga = require("../services/ga");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  white-space: normal;\n  line-height: 1.5;\n  font-size: 16px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 15px;\n\n  img {\n    display: block;\n    width: 100%;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  color: #fff;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  margin-right: 15px;\n  width: 380px;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  @media (max-width: 767px) {\n    width: 300px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  overflow: auto;\n  white-space: nowrap;\n  padding-bottom: 20px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var mountEventName = 'video-widget-mount';

var Container = _styledComponents.default.div(_templateObject());

var List = _styledComponents.default.ul(_templateObject2());

var Item = _styledComponents.default.li(_templateObject3());

var ItemLink = _styledComponents.default.a(_templateObject4());

var Image = _styledComponents.default.div(_templateObject5());

var Title = _styledComponents.default.div(_templateObject6());

function App(_ref) {
  var bus = _ref.bus;
  var content = bus.getContent();
  var _content$reactLayerCo = content.reactLayerConfig,
      reactLayerConfig = _content$reactLayerCo === void 0 ? {} : _content$reactLayerCo,
      isAuth = content.isAuth;

  var handleClick = function handleClick(e, _ref2) {
    var title = _ref2.title;
    (0, _ga.trackGAEvent)('video-widget', 'click', "title:".concat(title), isAuth);
  };

  return videos ? /*#__PURE__*/_react.default.createElement("section", {
    className: "section video-widget",
    id: "videos"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "section__title graphcms-container"
  }, "Published talk recordings"), /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(List, null, Object.keys(videos).map(function (video, i) {
    var _videos$video = videos[video],
        image = _videos$video.image,
        title = _videos$video.title,
        link = _videos$video.link;
    return /*#__PURE__*/_react.default.createElement(Item, {
      key: i
    }, /*#__PURE__*/_react.default.createElement(ItemLink, {
      href: link,
      target: "_blank",
      onClick: function onClick(e) {
        handleClick(e, {
          title: title
        });
      }
    }, /*#__PURE__*/_react.default.createElement(Image, null, /*#__PURE__*/_react.default.createElement("img", {
      src: image,
      alt: title
    })), /*#__PURE__*/_react.default.createElement(Title, null, title)));
  }))))) : null;
}

var mountApp = function mountApp(id, bus) {
  var mountNode = document.getElementById(id);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(App, {
    bus: bus
  }), mountNode);
};

var initVideoWidget = function initVideoWidget(bus) {
  var onEvent = function onEvent(_ref3) {
    var type = _ref3.type,
        payload = _ref3.payload;

    if (type === 'mount' && payload.name === mountEventName) {
      mountApp(payload.id, bus);
    }
  };

  bus.subscribe(onEvent);
};

exports.initVideoWidget = initVideoWidget;